import { call, put, takeEvery } from 'redux-saga/effects';
import { gcApi } from 'config/axios';
import { handlingErrorCallback, handlingSuccessCallback } from './sagasUtils';
import {
    FETCH_SUBSCRIBER_EVENT_DETAILS,
    FETCH_SUBSCRIBER_EVENT_DETAILS_FETCHING,
    FETCH_SUBSCRIBER_EVENT_DETAILS_SUCCESS,
    FETCH_SUBSCRIBER_EVENT_DETAILS_FAIL,
    FETCH_EVENTS_BY_DATE_SUCCESS,
    FETCH_EVENTS_BY_DATE_ERROR,
    FETCH_EVENTS_BY_DATE_FETCHING,
    FETCH_EVENTS_BY_DATE,
    FETCH_RACE_EVENT_PROVIDERS,
    FETCH_RACE_EVENT_PROVIDERS_FETCHING,
    FETCH_RACE_EVENT_PROVIDERS_SUCCESS,
    FETCH_RACE_EVENT_PROVIDERS_FAIL
} from '../actions/ActionTypes';
import UrlParser from 'utils/parsers/UrlParser';

const urlParser = new UrlParser();

// Workers
export function* fetchSubscriberEventDetails(action) {
    const { shareableEventUuid, callback } = action;

    try {
        yield put({
            type: FETCH_SUBSCRIBER_EVENT_DETAILS_FETCHING
        });
        const response = yield call(gcApi.get, `/calendar-service/event/${shareableEventUuid}/shareable`);

        yield put({
            type: FETCH_SUBSCRIBER_EVENT_DETAILS_SUCCESS,
            event: response.data
        });
        if (callback) {
            yield call(handlingSuccessCallback, callback, response);
        }
    } catch (e) {
        yield put({
            type: FETCH_SUBSCRIBER_EVENT_DETAILS_FAIL,
            event: null
        });
        if (callback) {
            yield call(handlingErrorCallback, callback, e);
        }
    }
}

export function* fetchEventsByDate(action) {
    const { startDate, endDate, eventType, pageIndex, limit, sort, callback } = action;

    let params = {
        startDate: startDate,
        endDate: endDate,
        eventType: eventType,
        pageIndex: pageIndex,
        limit: limit,
        sortOrder: sort
    };

    try {
        yield put({
            type: FETCH_EVENTS_BY_DATE_FETCHING
        });

        const response = yield call(
            gcApi.get,
            `/calendar-service/events${urlParser.convertObjectToQueryString(params)}`
        );

        yield put({
            type: FETCH_EVENTS_BY_DATE_SUCCESS,
            events: response.data
        });
        yield call(handlingSuccessCallback, callback, response);
    } catch (e) {
        yield put({
            type: FETCH_EVENTS_BY_DATE_ERROR,
            events: null
        });
        yield call(handlingErrorCallback, callback, e);
    }
}

export function* fetchRaceEventProviders() {
    try {
        yield put({
            type: FETCH_RACE_EVENT_PROVIDERS_FETCHING
        });

        const response = yield call(gcApi.get, '/calendar-service/race-events/providers');

        yield put({
            type: FETCH_RACE_EVENT_PROVIDERS_SUCCESS,
            providers: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_RACE_EVENT_PROVIDERS_FAIL,
            providers: []
        });
    }
}

// Watchers
export const shareableEvent = [
    takeEvery(FETCH_SUBSCRIBER_EVENT_DETAILS, fetchSubscriberEventDetails),
    takeEvery(FETCH_EVENTS_BY_DATE, fetchEventsByDate),
    takeEvery(FETCH_RACE_EVENT_PROVIDERS, fetchRaceEventProviders)
];
